import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navigation from "@/components/wedding/Navigation";
import Hero from "@/components/wedding/Hero";
import Ticker from "@/components/wedding/Ticker";
import OurStory from "@/components/wedding/OurStory";
import TheDate from "@/components/wedding/TheDate";
import Location from "@/components/wedding/Location";
import LogisticsCTA from "@/components/wedding/LogisticsCTA";
import TravelStay from "@/components/wedding/TravelStay";
import Accommodation from "@/components/wedding/Accommodation";
import RSVP from "@/components/wedding/RSVP";
import FAQ from "@/components/wedding/FAQ";
import GiftList from "@/components/wedding/GiftList";
import PlaylistSection from "@/components/wedding/PlaylistSection";
import Footer from "@/components/wedding/Footer";
import Loader from "@/components/wedding/Loader";
import LogisticsPage from "@/components/wedding/LogisticsPage";
import AdminPlaylist from "@/pages/AdminPlaylist";
import AdminRsvp from "@/pages/AdminRsvp";

const WeddingSite = () => {
  return (
    <div className="relative min-h-screen bg-[#ECE7DC] text-[#0a0a0a]" data-testid="wedding-site">
      <Loader />
      <Navigation />
      <main>
        <Hero />
        <Ticker />
        <OurStory />
        <TheDate />
        <Location />
        <LogisticsCTA />
        <FAQ />
        <RSVP />
        <GiftList />
        <PlaylistSection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster
          position="bottom-center"
          toastOptions={{
            style: {
              background: "#0a0a0a",
              color: "#f4efe3",
              border: "1px solid #0a0a0a",
              borderRadius: 0,
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: "12px",
              letterSpacing: "0.05em",
              textTransform: "uppercase",
            },
          }}
        />
        <Routes>
          <Route path="/" element={<WeddingSite />} />
          <Route path="/logistica" element={<LogisticsPage />} />
          <Route path="/admin/playlist" element={<AdminPlaylist />} />
          <Route path="/admin/rsvp" element={<AdminRsvp />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
